import apiService from './ApiService';

export default class SmsLogApiService {
    /**
     * Search messages this application sent.
     *
     * Paged on the server: a single broadcast queues a row per subscriber, so this table is far too
     * large to pull down and filter in the browser.
     * @param query {{search?: string, status?: number|null, page: number, pageSize: number}}
     * @returns {Promise<ServiceResponse<{items: Array, totalCount: number}>>}
     */
    async searchOutbound(query) {
        const response = await apiService.getData(`api/SmsLog/outbound?${buildQueryString(query)}`);
        return response?.data;
    }

    /**
     * Search messages tenants sent in.
     * @param query {{search?: string, page: number, pageSize: number}}
     * @returns {Promise<ServiceResponse<{items: Array, totalCount: number}>>}
     */
    async searchInbound(query) {
        const response = await apiService.getData(`api/SmsLog/inbound?${buildQueryString(query)}`);
        return response?.data;
    }
}

/**
 * Builds the query string, dropping anything unset so an empty filter does not become the literal
 * text "undefined" on the server.
 * @param query {object}
 * @returns {string}
 */
function buildQueryString(query) {
    const parameters = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            parameters.append(key, value);
        }
    });

    return parameters.toString();
}
